import { IconAlertTriangleFilled, IconX } from '@tabler/icons-react';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NoticeBanner = ({
  content,
  onClose
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center justify-between h-12 px-6 py-3 bg-my-cyan-95",
    children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-1 text-my-gray-10 text-label-lg-600",
      children: [/*#__PURE__*/_jsx(IconAlertTriangleFilled, {
        size: 16,
        color: "var(--red-50)"
      }), content]
    }), /*#__PURE__*/_jsx("button", {
      onClick: onClose,
      children: /*#__PURE__*/_jsx(IconX, {
        size: 24,
        color: "var(--gray-10)"
      })
    })]
  });
};
export default NoticeBanner;